import cx from 'classnames';
import * as Modules from 'components/modules';
import { throttle } from 'lodash';
import { MEDIA_IS_READY } from 'config';
import { delay } from 'helpers';
import React from 'react';
import reactHtmlParser from 'react-html-parser';
import { CSSTransition } from 'react-transition-group';
import { push } from 'redux-first-router';
import styles from './preview.css';
import * as s from './styled';

class Preview extends React.Component {
  state = { transition: false, maxHeight: false };

  componentDidMount() {
    this.manageResizeListeningOnStart();
    delay(1000)
      .then(this.props.setPageReady)
      .catch(console.log);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledResizeListener);
  }

  manageResizeListeningOnStart = () => {
    this.documentHeight = document.documentElement.clientHeight;
    window.addEventListener('resize', this.throttledResizeListener);
  };

  manageVideoPlayingOnStart = () => {
    if (this.videoRef.current.readyState === MEDIA_IS_READY) {
      this.props.setPageReady();
    }
  };
  throttledResizeListener = throttle(() => {
    this.documentHeight = document.documentElement.clientHeight;
    this.forceUpdate();
  }, 400);

  clickHandler = (e) => {
    e && e.preventDefault();
    Promise.resolve()
      .then(() => {
        this.setState({
          transition: true,
        });
      })
      .then(() => delay(1000))
      .then(() => {
        this.setState({
          transition: false,
        });
      })
      .catch(console.log);
  };

  videoRef = React.createRef();

  render() {
    const {
      video,
      href,
      colors,
      mode,
      heroTitle,
      i,
      code,
      setPageReady,
    } = this.props;
    const { transition, maxHeight } = this.state;
    return (
      <CSSTransition
        onEntered={() => {
          this.setState({ maxHeight: true });
          const wrapper = document.querySelector('#wrapper');
          wrapper.style.overflow = 'hidden';
          wrapper.scrollTop = 0;
          push(href);
          delay(400).then(() => {
            this.setState({ maxHeight: false });
          });
          wrapper.style.overflowY = 'scroll';
        }}
        timeout={800}
        in={transition}
        classNames={{
          enter: 'enter',
          enterActive: 'enterActive',
          exit: 'exit',
          exitActive: 'exitActive',
        }}
      >
        <s.Section
          mode={mode}
          innerRef={section => (this.section = section)}
          className={cx(styles[mode], maxHeight && 'maxHeight')}
          customHeight={this.documentHeight}
        >
          {i === 0 && (
            <div className={styles.visibilityWrapper}>
              <Modules.VisibilitySensor
                color={colors.logo}
                id={`section-${0}`}
                scrollIndex={0}
                code={code}
              >
                <div className={styles.visibilityPlaceholder} />
              </Modules.VisibilitySensor>
            </div>
          )}
          <s.VideoContainer>
            <s.Video
              innerRef={this.videoRef}
              onCanPlay={setPageReady}
              playsInline
              autoPlay
              loop
              muted
              preload
              as="video/*"
              src={`${video.src}`}
            />
          </s.VideoContainer>
          <s.Overlay
            className={styles.overlay}
            backgroundColor={colors.overlay}
          />

          {mode === 'footer' ? (
            <s.StyledLink
              color={colors.title}
              onClick={this.clickHandler}
              to={href}
              className={cx(styles.link)}
            >
              <p className={styles.pointer}>Следующий проект</p>
              <h2 className={styles.title}>{reactHtmlParser(heroTitle)}</h2>
            </s.StyledLink>
          ) : (
            <s.TitleWrapper color={colors.title} className={cx(styles.link)}>
              <p className={styles.pointer}>Следующий проект</p>
              <h2 className={styles.title}>{reactHtmlParser(heroTitle)}</h2>
            </s.TitleWrapper>
          )}
        </s.Section>
      </CSSTransition>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/modules/PreviewManager/Preview.js